import { BaseTextMergeContainerElement } from "../BaseTextMergeContainerElement";
import { TextMergeConfiguration } from "../../TextMergeConfiguration";
import { TextMergeType } from "../../TextMergeType";

export class BlockQuoteElement extends BaseTextMergeContainerElement {
    readonly __type = "blockquote";
    readonly name = "Block Quote";
    readonly styleElement: boolean = true;
    readonly ordinal: number = 10;

    getHTMLTag(): string {
        return "block";
    }

    canAdd(config: TextMergeConfiguration): boolean {
        return config.type === TextMergeType.HTML;
    }
}
